import { palette } from "../palette";

export const theme = {
  background: palette.white[100],
  text: {
    default: palette.black[100],
    secondary: palette.black[40],
  },
  header: {
    background: palette.white[100],
  },
  body: {
    background: palette.ebb[100],
  },
  form: {
    background: palette.white[100],
  },
  error: {
    background: palette.red[100],
  },
  button: {
    background: {
      primary: palette.stone[100],
      secondary: palette.ebb[100],
      disabled: palette.gray[60],
    },
    text: {
      primary: palette.white[100],
      secondary: palette.black[100],
    },
  },
  chart: {
    background: palette.stone[100],
    returned: palette.xanadu[100],
    invested: palette.white[100],
    text: palette.white[100],
    icon: palette.white[100],
    footer: palette.alto[20],
  },
  checkbox: {
    default: palette.white[100],
    variant: palette.ebb[100],
  },
  loader: {
    default: palette.stone[100],
    secondary: palette.stone[60],
    inverse: palette.white[100],
  },
  input: {
    background: palette.ebb[100],
    text: palette.black[100],
    placeholder: palette.black[40],
    error: palette.red[100],
    selected: {
      background: palette.black[100],
      text: palette.white[100],
    },
  },
  item: {
    background: palette.white[100],
    highlight: palette.gray[20],
  },
  icon: {
    default: palette.black[100],
  },
  link: {
    default: palette.blue[100],
    secondary: palette.lightbrown[100],
  },
  modal: {
    backdrop: palette.darkblack[100],
    background: palette.white[100],
  },
  footer: {
    default: palette.black[100],
    secondary: palette.black[40],
  },
  border: palette.ebb[100],
  exclusive: {
    default: palette.teal[100],
  },
  validator: {
    valid: palette.teal[100],
    invalid: palette.burgundy[100],
  },
  switch: {
    background: palette.teal[100],
  },
  slider: {
    background: palette.white[100],
  },
  progress: {
    default: palette.stone[100],
  },
};
